// extracted by css-extract-rspack-plugin
export default {"wrapper":"wrapper--_91wJMb1wQHF27Sl"};